<template>
    <v-flex class="check-list__cont">
        <v-checkbox
            class="check-list__cont__select-all"
            v-model="select_All"
            label="Select All"
            color="ypo_cta"
            v-on:change="checkSelectAllMember()"
            hide-details
            data-qe-id="prpMember_checkbox_select_all"></v-checkbox>
        <v-flex class="check-list__cont__check-items" v-for="(prpMember,i) in prpMemberList" :key="i">
            <v-checkbox v-model="selections" :disabled="disableCheckBox(prpMember)" :label="userName(prpMember)" :value="prpMember.id" color="ypo_cta" v-on:change="checkSingleMember()" hide-details :data-qe-id="`prpMember_checkbox_${i}`">
            </v-checkbox>
            <i class="fas fa-vote-yea voted approved" v-if="showVotedApproved(prpMember)" title="approved" :data-qe-id="`prpMember_approved_${i}`"></i>
            <i class="fas fa-vote-yea voted denied" v-else-if="showVotedDenied(prpMember)" title="denied" :data-qe-id="`prpMember_denied_${i}`"></i>
        </v-flex>
    </v-flex>
</template>

<script>
    import { chapterWaiverConstants } from "./ChapterWaiver.constants";
    import { mapGetters, mapActions } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";

    export default {
        name: "PanelMemberList",
        created() {
            this.getPRPMemberList();
            this.checkSelectedMembers();
        },
        data: () => {
            return {
                chapterWaiverConstants,
                selections: [],
                select_All: false,
            };
        },
        methods: {
            ...mapActions({
                getPRPMemberList: `chapterWaiver/${storeAction.getPRPMemberList}`,
            }),
            userName(prpMember) {
                return `${prpMember.firstName} ${prpMember.lastName}`;
            },
            checkSelectAllMember() {
                if (!this.select_All && this.waiverVotes) {
                    const voterIds = this.waiverVotes.map(x => x.panelId);
                    this.selections = this.selections.filter((item) => {
                                        return voterIds.includes(item); 
                                    });
                    return;
                }
                this.selections = [];
                if (this.select_All) {
                    this.selections = this.prpMemberList.map(x => x.id);
                }
            },
            checkSingleMember() {
                if (this.selections.length !== this.prpMemberList.length) {
                    this.select_All = false;
                }
            },
            disableCheckBox(prpMember) {
                return prpMember && this.waiverVotes && this.waiverVotes.some(x => x.panelId === prpMember.id);
            },
            showVotedApproved(prpMember) {
                return prpMember && this.waiverVotes && this.waiverVotes.some(x => x.panelId === prpMember.id && x.voteStatus.toLowerCase() === "approved");
            },
            showVotedDenied(prpMember) {
                return prpMember && this.waiverVotes && this.waiverVotes.some(x => x.panelId === prpMember.id && x.voteStatus.toLowerCase() === "denied");
            },
            checkSelectedMembers() {
                if (this.waiverVotes) {
                    this.selections = this.waiverVotes.map(x => x.panelId);
                }
            },
        },
        computed: {
            ...mapGetters({
                prpMemberList: `chapterWaiver/${storeGetters.prpMemberList}`,
            }),
        },
        props: {
            waiverVotes: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss">
    .check-list__cont__check-items {
        position: relative;
        .voted {
            position: absolute;
            right: 0;
            top: 6px;
        }
    }
    .approved {
        color:green;
    }
    .denied {
        color: red;
    }

</style>
